import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../../store/LoginActionsReducers';
import { withRouter } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import FormControl from '@material-ui/core/FormControl';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import CallLog from './CallLog';
import Contacts from './Contacts';
import Details from './Details';
import Reports from './Reports';
import Financials from './Financials';
import Providers from './Providers';
import RevenueCategoryMappings from './RevenueCategoryMappings';
import CodeGroupMappings from './CodeGroupMappings';
import Login from '../Login/Login';
import api from '../../ApiService';
import { toast } from 'react-toastify';
import { UserRoles, UserRelationshipTypes, HospitalViewTabs } from '../../helper';
import DropdownSelect from '../DropdownSelect';
import IntraCompanyCustomerMappings from './IntraCompanyCustomerMappings';
import IVet360Team from './IVet360Team';

class Hospitals extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hospitalListOpen: false,
            selectedTab: null,
            hospitals: [],
            selectedHospital: undefined,
            originalHospital: undefined,
            affiliates: [],
            serviceLevels: [],
            hospitalTypes: [],
            gpoOptions: [],
            reportBrandings: [],
            staffUsers: [],
            iVetPMS: [],
            defaultGpoOptionId: null,
            //showReloadGoogleAnalyticsModal: false,
            isDirty: false
        };
    }

    componentDidMount = async () => {
        if (this.props.isAuthenticated && this.state.hospitals.length === 0) this.loadHospitalsData();
    }

    componentDidUpdate = () => {
        // data check for the rare occassions when hospital list is not loaded.
        if (this.props.isAuthenticated && this.state.hospitals.length === 0) this.loadHospitalsData();
    }

    loadHospitalsData = async () => {
        let isStaffManagementOrAbove = this.props.userRole === UserRoles.Administrator
            || this.props.userRole === UserRoles.SuperUser
            || this.props.userRole === UserRoles.StaffManagement;

        // Load data.
        let hospitals = await api.getHospitals();

        // This stuff only matters to Details component (admin-only).
        let affiliates = [], serviceLevels = [], hospitalTypes = [], gpoOptions = [], reportBrandings = [], staffUsers = [], iVetPMS = [];
        if (hospitals && hospitals.length > 0) {
            // Include 'Create' item if admin / super user
            let selectedHospital = null;

            if (isStaffManagementOrAbove) {
                affiliates = await api.getLookup('Affiliates');
                serviceLevels = await api.getLookup('Service Levels');
                hospitalTypes = await api.getLookup('Hospital Types');
                gpoOptions = await api.getLookup('GPO Options');
                reportBrandings = await api.getLookup('Report Brandings');
                staffUsers = await api.getUserSelectOptions('staff');
                iVetPMS = await api.getLookup('iVetPMS');

                hospitals.unshift({ name: 'NEW', description: 'Create Hospital', nameHash: 'NEW' });
                selectedHospital = this.getBlankHospital();
            }
            else {
                selectedHospital = await api.getHospital(hospitals[0].nameHash);
            }

            let defaultGpoOptionId = this.state.defaultGpoOptionId;
            if (gpoOptions.length > 0) {
                let noneOption = gpoOptions.find(x => x.name === 'None');
                if (noneOption) defaultGpoOptionId = noneOption.id;
            }

            let permittedTabs = this.getPermittedTabs(selectedHospital);
            let selectedTab = HospitalViewTabs.HospitalInfo;
            if (permittedTabs.find((x) => x === HospitalViewTabs.Pulse) !== undefined)
                selectedTab = HospitalViewTabs.Pulse;
            if (affiliates && serviceLevels && hospitalTypes && gpoOptions && reportBrandings) {
                await this.setState({
                    hospitals, affiliates, serviceLevels, hospitalTypes, gpoOptions, defaultGpoOptionId, reportBrandings,
                    staffUsers, selectedHospital, originalHospital: selectedHospital, selectedTab, iVetPMS
                });
            }
            else {
                this.props.signOut();
            }
        }
        else {
            this.props.signOut();
        }
    }

    handleDetailsAffiliateChange = item => {
        this.updateDetailsValue(null, "affiliateId", item.id);
    }

    handleHospitalChange = async item => {
        if (item && item.value !== 'NEW') {
            // get hash
            let h = this.state.hospitals.find(x => x.name === item.value);
            var selectedHospital = await api.getHospital(h.nameHash);
            var originalHospital = Object.assign({}, selectedHospital); // shallowCopy
        }
        else {
            selectedHospital = this.getBlankHospital();
            originalHospital = this.getBlankHospital();
        }

        // Reset selected tab if no longer permitted.
        let selectedTab = this.state.selectedTab;
        // For StaffManagement, setting 'Pulse' tab as default
        if (this.props.userRole === UserRoles.StaffManagement) selectedTab = HospitalViewTabs.Pulse;
        let permittedTabs = this.getPermittedTabs(selectedHospital);
        if (!permittedTabs.includes(selectedTab))
            selectedTab = permittedTabs[0];

        this.setState({
            selectedHospital, originalHospital,
            selectedTab, isDirty: false
        });

        // Update component
        if (selectedTab === HospitalViewTabs.Pulse) {
            // This is a tricky, but accepted way to communicate events to the child
            this.alertReportsComponentOfHospitalChange(selectedHospital);
        }
        else if (selectedTab === HospitalViewTabs.CoaMapping) {
            this.alertFinancialsComponentOfHospitalChange(selectedHospital);
        }
        else if (selectedTab === HospitalViewTabs.CodeMapping) {
            this.alertCodeGroupMappingsComponentOfHospitalChange(selectedHospital);
        }
        else if (selectedTab === HospitalViewTabs.RevenueMapping) {
            this.alertRevenueCategoryMappingsComponentOfHospitalChange(selectedHospital);
        }
        else if (selectedTab === HospitalViewTabs.CallLog) {
            this.alertCallLogComponentOfHospitalChange(selectedHospital);
        }
        else if (selectedTab === HospitalViewTabs.Contacts) {
            this.alertContactsComponentOfHospitalChange(selectedHospital);
        }
        else if (selectedTab === HospitalViewTabs.Providers) {
            this.alertProvidersComponentOfHospitalChange(selectedHospital);
        }
        else if (selectedTab === HospitalViewTabs.Analyst) {
            this.alertReportsComponentOfHospitalChange(selectedHospital);
        }
        else if (selectedTab === HospitalViewTabs.IVet360Team) {
            this.alertIVet360TeamComponentOfHospitalChange(selectedHospital);
        }
    };

    handleDetailsChange = event => {
        // just set the dirty flag
        if (!this.state.isDirty) this.setState({ isDirty: true });
    }

    handleDetailsCheckboxChange = (event, fieldName) => {
        this.updateDetailsValue(null, event.target.value, event.target.checked);
    }

    handleDetailsRadioChange = event => {
        this.updateDetailsValue(event.target.id, event.target.name, event.target.value);
    }

    // We can use this for dropdowns since defaultValue will be undefined
    // We can't use this for radios since defaultValue always equals value
    handleDetailsBlur = event => {
        // anytime this handler is used a defaultValue must be provided
        if (event.target.defaultValue !== event.target.value) {
            this.updateDetailsValue(event.target.id, event.target.name, event.target.value);
        }
    }

    updateDetailsValue(targetId, targetName, newValue) {
        // compare and update state if data changed
        let elementId = targetId;
        // some controls only populate the name, not the id
        if (elementId === undefined || elementId === null || elementId.length === 0) {
            elementId = targetName;
        }

        let hospital = { ...this.state.selectedHospital };

        // Ug. RadioGroup does a strict compare with the value, so we must make
        // sure to make these Numbers or the radio button will not be checked
        if (elementId === 'status' || elementId === 'sync') {
            hospital[elementId] = Number(newValue);
        }
        else {
            hospital[elementId] = newValue;
        }

        // Go ahead and set isDirty here since some controls will only use this handler
        this.setState({ selectedHospital: hospital, isDirty: true });
    }

    validateDate = (date) => {
        let year = date.split('-')[0];
        if (year.length > 4) return false;
        try {
            new Date(date).toISOString();
            return true;
        } catch (err) {
            return false;
        }
    }

    handleDetailsCancel = () => {
        this.setState({ selectedHospital: this.state.originalHospital, isDirty: false });
    }

    handleDetailsSave = async () => {
        let iVetUserAppUserAccess = this.state.selectedHospital.iVetUserAppUserAccessUserIds.map(id => ({
            idIVetUser: this.state.selectedHospital.idiVetUser,
            appUserId: id
        }));
        await this.setState(prevState => ({
            selectedHospital: {
                ...prevState.selectedHospital,
                iVetUserAppUserAccess
            }
        }));

        // validating the date entries.
        let dateKeys = Object.keys(this.state.selectedHospital).filter(key => key.includes("Date"));
        //console.log(dateKeys);
        let dateValidate = dateKeys.every(key => (this.state.selectedHospital[key]) ? this.validateDate(this.state.selectedHospital[key]) : true);
        // exists if one of the date entries is not valid
        if (!dateValidate) {
            toast.error("Unable to save. Please check the date entries.");
            return;
        }

        if (isNaN(this.state.selectedHospital.physicalLocations)) {
            if (!this.state.selectedHospital.physicalLocations) {
                toast.error("Unable to save. Physical Locations cannot be empty.");
                return;
            }
        }

        let response = await api.saveHospital(this.state.selectedHospital);

        if (response.ok) {
            let hospital = response.data;
            if (this.state.selectedHospital.idiVetUser === 0) {
                toast.success("Hospital created.");

                // new one added, refresh list
                let hospitals = await api.getHospitals();
                if (hospitals) {
                    hospitals.unshift({ name: 'NEW', description: 'Create Hospital', nameHash: 'NEW' });
                    this.setState({ hospitals });
                }
                // and reselect it
                this.setState({
                    selectedHospital: hospital,
                    originalHospital: Object.assign({}, hospital),
                    isDirty: false
                });
            }
            else {
                toast.success("Hospital updated.");

                // If name or description changed then update the item in the select list
                let hIdx = this.state.hospitals.findIndex(x => x.nameHash === hospital.nameHash);
                let hospitals = this.state.hospitals.slice();
                hospitals[hIdx].name = hospital.name;
                hospitals[hIdx].description = hospital.description;
                this.setState({
                    hospitals,
                    selectedHospital: hospital,
                    originalHospital: Object.assign({}, hospital),
                    isDirty: false
                });
            }
        }
        else if (response.status === 401) {
            this.props.signOut();
        }
    }

    getBlankHospital = () => {
        return {
            idiVetUser: 0,
            name: '',
            nameHash: '',
            description: '',
            address: '',
            city: '',
            state: '',
            zip: '',
            region: '',
            deliveryTeam: '',
            installationId: '',
            profileId: '',
            isActive: true,
            status: -1, // -1 = Temporary Hold, 0 = Hold, 1 = OK
            sync: -1, // -1 = Temporary Hold, 0 = Hold, 1 = Sync
            physicalLocations: null,
            firstBillDate: null,
            terminationDate: null,
            acquisitionDate: null,
            webLaunchDate: null,
            pms: '',
            dataPointSiteId: null,
            callTrackingSiteId: null,
            affiliateId: 0,
            serviceLevelId: 0,
            gpoOptionId: this.state.defaultGpoOptionId || null,
            reportBrandingId: null,
            siteId: '',
            intacctLocationId: '',
            ezyVetClientId: '',
            ezyVetClientSecret: '',
            analyticsManager: '',
            marketingManager: '',
            hrtManager: '',
            iVetUserAppUserAccessUserIds: [],
            iVetUserAppUserAccess: [],
            squareFootage: null,
            notes: '',
            powerBiPayments: false,
            isLearningVetClient: false,
            learningVetStartDate: null,
            learningVetTerminationDate: null,
            learningVetRate: 0,
            monthlyBillRate: 0
        };
    }

    getPermittedTabs = (hospital) => {
        if (!hospital || hospital.idiVetUser === 0 || !hospital.serviceLevel)
            return [HospitalViewTabs.HospitalInfo];

        let isStaff = this.props.userRole === UserRoles.Administrator
            || this.props.userRole === UserRoles.SuperUser
            || this.props.userRole === UserRoles.StaffManagement
            || this.props.userRole === UserRoles.StaffAnalyticsManager
            || this.props.userRole === UserRoles.StaffUser;
        let showAll = this.props.userRole === UserRoles.Administrator
            || this.props.userRole === UserRoles.SuperUser
            || this.props.userRole === UserRoles.StaffManagement;
        let iVetStaffAnalyticsManagerAndAbove = this.props.userRole === UserRoles.Administrator
            || this.props.userRole === UserRoles.SuperUser
            || this.props.userRole === UserRoles.StaffManagement
            || this.props.userRole === UserRoles.StaffAnalyticsManager;


        let permissibleTabs = [
            HospitalViewTabs.Pulse,
            HospitalViewTabs.Marketing,
            HospitalViewTabs.Budget,
            HospitalViewTabs.CoaMapping,
            HospitalViewTabs.CodeMapping,
            HospitalViewTabs.RevenueMapping,
            HospitalViewTabs.CallLog,
            HospitalViewTabs.Contacts,
            HospitalViewTabs.IVet360Team,
            HospitalViewTabs.HospitalInfo,
            HospitalViewTabs.Providers,
            HospitalViewTabs.Analyst,
            HospitalViewTabs.IntraCompanyCustomerMapping
        ];

        let permissions = hospital.serviceLevel.hospitalFeaturePermissions.slice();
        let tabs = [];
        permissibleTabs.forEach((featureTab) => {
            let found = permissions.find((x) => {
                return x === featureTab;
            });

            // Only Staff AM, Staff Management, Admin and Super User will see the Providers tab.
            if (!iVetStaffAnalyticsManagerAndAbove && featureTab === HospitalViewTabs.Providers) return;
            // Show Analyst tab if Pulse tab is visible and showAnalystUi is true
            if (tabs.includes(HospitalViewTabs.Pulse) && featureTab === HospitalViewTabs.Analyst) {
                if (((this.props.userRole === UserRoles.User || this.props.userRole === UserRoles.AffiliateAnalyticsManager) && hospital.showAnalystUi)
                    || iVetStaffAnalyticsManagerAndAbove) tabs.push(featureTab);
                return;
            }
            // Show if permitted.  Note that call log tab is not visible to any iVet staff unless it is explicitly
            // listed as permissible for the hospital.
            if (found !== undefined || (showAll && featureTab !== HospitalViewTabs.CallLog)
                || (this.props.userRole === UserRoles.StaffAnalyticsManager
                    && (featureTab === HospitalViewTabs.CoaMapping
                        || featureTab === HospitalViewTabs.CodeMapping
                        || featureTab === HospitalViewTabs.RevenueMapping
                        || featureTab === HospitalViewTabs.Providers))
                || (this.props.userRole === UserRoles.AffiliateAnalyticsManager
                    && featureTab === HospitalViewTabs.RevenueMapping)
                || (this.props.userRole === UserRoles.PathwayStaffAnalyticsManager
                    && featureTab === HospitalViewTabs.IntraCompanyCustomerMapping)
                || (isStaff && featureTab === HospitalViewTabs.Contacts)) {
                tabs.push(featureTab);
            }
        });

        return tabs;
    }

    renderTabs = () => {
        let tabsToRender = [];
        let permittedTabs = this.getPermittedTabs(this.state.selectedHospital);

        if (this.state.selectedHospital && this.state.selectedHospital.idiVetUser !== 0) {
            if (permittedTabs.includes(HospitalViewTabs.Pulse))
                tabsToRender.push(<Tab label="Pulse" key={HospitalViewTabs.Pulse} value={HospitalViewTabs.Pulse} />);
            if (permittedTabs.includes(HospitalViewTabs.Budget) && this.state.selectedHospital.budgetReviewGoogleDocsUrl)
                tabsToRender.push(<Tab label="Budget" key={HospitalViewTabs.Budget} value={HospitalViewTabs.Budget} />);
            if (permittedTabs.includes(HospitalViewTabs.Analyst))
                tabsToRender.push(<Tab label="Analyst" key={HospitalViewTabs.Analyst} value={HospitalViewTabs.Analyst} />);
            if (permittedTabs.includes(HospitalViewTabs.Marketing) && this.state.selectedHospital.marketingGoogleDocsUrl)
                tabsToRender.push(<Tab label="Marketing" key={HospitalViewTabs.Marketing} value={HospitalViewTabs.Marketing} />);

            if (permittedTabs.includes(HospitalViewTabs.CallLog))
                tabsToRender.push(<Tab label="Calls" key={HospitalViewTabs.CallLog} value={HospitalViewTabs.CallLog} />);

            if (permittedTabs.includes(HospitalViewTabs.CodeMapping))
                tabsToRender.push(<Tab label="Code Mapping" key={HospitalViewTabs.CodeMapping} value={HospitalViewTabs.CodeMapping} />);
            if (permittedTabs.includes(HospitalViewTabs.RevenueMapping))
                tabsToRender.push(<Tab label="Revenue Mapping" key={HospitalViewTabs.RevenueMapping} value={HospitalViewTabs.RevenueMapping} />);
            if (permittedTabs.includes(HospitalViewTabs.CoaMapping))
                tabsToRender.push(<Tab label="COA Mapping" key={HospitalViewTabs.CoaMapping} value={HospitalViewTabs.CoaMapping} />);

            if (permittedTabs.includes(HospitalViewTabs.Contacts))
                tabsToRender.push(<Tab label="Contacts" key={HospitalViewTabs.Contacts} value={HospitalViewTabs.Contacts} />);
            if (permittedTabs.includes(HospitalViewTabs.Providers))
                tabsToRender.push(<Tab label="Providers" key={HospitalViewTabs.Providers} value={HospitalViewTabs.Providers} />);
            if (permittedTabs.includes(HospitalViewTabs.IVet360Team))
                tabsToRender.push(<Tab id="ivet360-team" label="iVET360 TEAM" key={HospitalViewTabs.IVet360Team} value={HospitalViewTabs.IVet360Team} />);
        }

        if (permittedTabs.includes(HospitalViewTabs.HospitalInfo))
            tabsToRender.push(<Tab label="Hospital Info" key={HospitalViewTabs.HospitalInfo} value={HospitalViewTabs.HospitalInfo} disabled={!this.state.selectedHospital} />);

        if (permittedTabs.includes(HospitalViewTabs.IntraCompanyCustomerMapping))
            tabsToRender.push(<Tab label="Intra Company Mapping" key={HospitalViewTabs.IntraCompanyCustomerMapping} value={HospitalViewTabs.IntraCompanyCustomerMapping} disabled={!this.state.selectedHospital} />);

        let selectedTab = this.state.selectedTab;
        if (selectedTab === null || !permittedTabs.includes(selectedTab)) selectedTab = permittedTabs[0];

        return (
            <Tabs value={selectedTab} variant="scrollable" scrollButtons="auto" scrollable onChange={(event, value) => this.setState({ selectedTab: value })}  >
                {tabsToRender.map((value) => value)}
            </Tabs>
        );
    }

    renderIFrame = (title, url) => {
        let style = { margin: 0, padding: 0, minHeight: "450px", height: "82.5vh", width: "100%" };
        return (
            <div>
                <iframe title={title} src={url} style={style} />
            </div>
        );
    }

    getHospitalSelectLabel(hospital, showHospitalId) {
		let label = `${(showHospitalId ? hospital.name + " - " : "")}${hospital.description}`;
        if (hospital.city && hospital.state) label += ` (${hospital.city}, ${hospital.state})`;
        if (!hospital.isActive && hospital.name !== 'NEW') label += ' - Inactive';

        // Service level is adding to hospital title for GPO users.
        let gpoRelationshipTypes = [
            UserRelationshipTypes.GpoAreaManager,
            UserRelationshipTypes.GpoDistrictManager,
            UserRelationshipTypes.GpoEnterprise
        ];
        if (gpoRelationshipTypes.includes(this.props.auth.user.userRelationshipType)) label += ` - ${hospital.serviceLevel ? hospital.serviceLevel.name : hospital.serviceLevelName}`;

        return label;
    }

    render() {
        if (!this.props.isAuthenticated) {
            return <Login />;
        }

        let showHospitalList = this.props.userRole === UserRoles.StaffUser
            || this.props.userRole === UserRoles.StaffAnalyticsManager
            || this.props.userRole === UserRoles.Administrator
            || this.props.userRole === UserRoles.SuperUser
            || this.props.userRole === UserRoles.StaffManagement
            || this.props.userRelationshipType !== UserRelationshipTypes.Hospital;

        let showHospitalId = !(this.props.userRole === UserRoles.User || this.props.userRole === UserRoles.AffiliateAnalyticsManager);

        const hospitals = this.state.hospitals.map(hospital => ({
            value: hospital.name,
            label: this.getHospitalSelectLabel(hospital, showHospitalId)
        }));

        return (
            <div>
                <Row>
                    <Col sm={6}>
                        {showHospitalList &&
                            <form>
                            <FormControl style={{ minWidth: '200px', display: 'flex' }}>
                                <DropdownSelect
                                    placeholder='Hospital'
                                    options={hospitals}
                                    handleChange={this.handleHospitalChange}
                                />
                                </FormControl>
                            </form>
                        }
                        {!showHospitalList &&
                            <h3>{this.state.selectedHospital ? this.state.selectedHospital.description : ''}</h3>
                        }
                    </Col>
                </Row>
                <Row>
                    <Col sm={12}>
                        {this.renderTabs()}
                    </Col>
                </Row>
                {this.state.selectedTab === HospitalViewTabs.HospitalInfo && this.state.selectedHospital &&
                    <Details selectedHospital={this.state.selectedHospital}
                        affiliates={this.state.affiliates}
                        serviceLevels={this.state.serviceLevels}
                        hospitalTypes={this.state.hospitalTypes}
                        gpoOptions={this.state.gpoOptions}
                        reportBrandings={this.state.reportBrandings}
                        staffUsers={this.state.staffUsers}
                        handleAffiliateChange={this.handleDetailsAffiliateChange}
                        handleChange={this.handleDetailsChange}
                        handleCheckboxChange={this.handleDetailsCheckboxChange}
                        handleRadioChange={this.handleDetailsRadioChange}
                        handleBlur={this.handleDetailsBlur}
                        onClickCancel={this.handleDetailsCancel}
                        onClickSave={this.handleDetailsSave}
                        isDirty={this.state.isDirty}
                        userRole={this.props.userRole}
                        iVetPMS={this.state.iVetPMS}
                    />
                }
                {this.state.selectedTab === HospitalViewTabs.Pulse &&
                    <Reports selectedHospital={this.state.selectedHospital}
                        alertReportsComponentOfHospitalChange={x => this.alertReportsComponentOfHospitalChange = x}
                        userRole={this.props.userRole}
                    />
                }
                {this.state.selectedTab === HospitalViewTabs.CoaMapping &&
                    <Financials selectedHospital={this.state.selectedHospital}
                        alertFinancialsComponentOfHospitalChange={x => this.alertFinancialsComponentOfHospitalChange = x}
                    />
                }
                {this.state.selectedTab === HospitalViewTabs.Budget &&
                    this.renderIFrame('budget', this.state.selectedHospital.budgetReviewGoogleDocsUrl)
                }
                {this.state.selectedTab === HospitalViewTabs.Marketing &&
                    this.renderIFrame('marketing', this.state.selectedHospital.marketingGoogleDocsUrl)
                }
                {this.state.selectedTab === HospitalViewTabs.CodeMapping &&
                    <CodeGroupMappings selectedHospital={this.state.selectedHospital}
                        alertCodeGroupMappingsComponentOfHospitalChange={x => this.alertCodeGroupMappingsComponentOfHospitalChange = x}
                    />
                }
                {this.state.selectedTab === HospitalViewTabs.RevenueMapping &&
                    <RevenueCategoryMappings selectedHospital={this.state.selectedHospital}
                        alertRevenueCategoryMappingsComponentOfHospitalChange={x => this.alertRevenueCategoryMappingsComponentOfHospitalChange = x}
                    />
                }
                {this.state.selectedTab === HospitalViewTabs.CallLog &&
                    <CallLog
                        selectedHospital={this.state.selectedHospital}
                        alertCallLogComponentOfHospitalChange={x => this.alertCallLogComponentOfHospitalChange = x}
                    />
                }
                {this.state.selectedTab === HospitalViewTabs.Contacts &&
                    <Contacts
                        selectedHospital={this.state.selectedHospital}
                        alertContactsComponentOfHospitalChange={x => this.alertContactsComponentOfHospitalChange = x}
                    />
                }
                {this.state.selectedTab === HospitalViewTabs.IVet360Team &&
                    <IVet360Team
                        selectedHospital={this.state.selectedHospital}
                    alertIVet360TeamComponentOfHospitalChange={x => this.alertIVet360TeamComponentOfHospitalChange = x}
                    />
                }
                {this.state.selectedTab === HospitalViewTabs.Providers &&
                    <Providers
                        selectedHospital={this.state.selectedHospital}
                        alertProvidersComponentOfHospitalChange={x => this.alertProvidersComponentOfHospitalChange = x}
                    />
                }
                {this.state.selectedTab === HospitalViewTabs.Analyst &&
                    <Reports selectedHospital={this.state.selectedHospital}
                        alertReportsComponentOfHospitalChange={x => this.alertReportsComponentOfHospitalChange = x}
                        userRole={this.props.userRole}
                        selectedTab={HospitalViewTabs.Analyst}
                    />
                }
                {this.state.selectedTab === HospitalViewTabs.IntraCompanyCustomerMapping &&
                    <IntraCompanyCustomerMappings selectedHospital={this.state.selectedHospital}
                        alertReportsComponentOfHospitalChange={x => this.alertReportsComponentOfHospitalChange = x}
                        userRole={this.props.userRole}
                        selectedTab={HospitalViewTabs.Analyst}
                    />
                }
            </div>
        );
    }
}

export default withRouter(connect(state => state.login,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Hospitals));


// WEBPACK FOOTER //
// ./src/components/Hospitals/Hospitals.js